function createForm(form: HTMLElement) {
	const select = form.querySelector<HTMLSelectElement>(
		'[data-conditional-select]',
	);
	const fields = form.querySelectorAll<HTMLElement>('[data-conditional-field]');

	if (!select) return;

	const matches = () =>
		select?.options[select?.selectedIndex]?.getAttribute(
			'data-conditional-match',
		) == 'true';

	const showFields = (show: boolean) => {
		fields.forEach((field) => {
			if (show) {
				field.style.removeProperty('display');

				if (field.dataset.cachedRequired) {
					field.setAttribute('required', field.dataset.cachedRequired);
				} else {
					field.removeAttribute('required');
				}
			} else {
				field.style.display = 'none';

				if (!field.dataset.cachedRequired && field.hasAttribute('required')) {
					field.dataset.cachedRequired = field.getAttribute('required') || '';
				}

				field.removeAttribute('required');
			}
		});
	};

	showFields(matches());

	select.addEventListener('change', () => {
		showFields(matches());
	});
}

const forms = document.querySelectorAll<HTMLElement>('[data-conditional-form]');

forms.forEach(createForm);
